import React, { useMemo } from 'react';

import styles from './ProgressBar.module.scss';

const { 'progress-bar': progressBarClass, 'current-step': currentStepClass } = styles;

const ProgressBar = ({ step, steps }) => {
  const totalProgress = useMemo(() => {
    return new Array(steps).fill().map((_, i) => (i < step ? 'complete' : 'incomplete'));
  }, [step, steps]);

  const mappedProgress = totalProgress.map((status, idx) => (
    <div
      className={`${currentStepClass} ${styles[status]} ${
        idx === 0 ? 'first' : idx === totalProgress.length - 1 ? 'last' : ''
      }`}
      key={idx}
    />
  ));
  return <div className={progressBarClass}>{mappedProgress}</div>;
};

export default ProgressBar;
